import { QUERY_KEYS } from "library/shared";
import { IUser } from "library/types";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { getUserDetails, getUserPhotoSmall } from "service/GraphService";

export function useUserData(userId?: string): UseQueryResult<IUser> {
  return useQuery({
    queryKey: [QUERY_KEYS.userData],
    queryFn: async () => {
      // Load both user data and photo in parallel
      const [userData, photoSmall] = await Promise.all([
        getUserDetails(userId),
        getUserPhotoSmall(userId),
      ]);

      // Combine them into a single object
      return {
        ...userData,
        photoSmall,
      };
    },
    enabled: true,
  });
}
